import { PriceBoostConfig } from '@frontend/sports/common/client-config-data-access';

export class OptionContextService {
    constructor(
        private priceBoostConfig: PriceBoostConfig,
        private isPriceBoostContext: boolean,
    ) {}

    get isPriceBoost(): boolean {
        return (this.priceBoostConfig.isEnabled || this.priceBoostConfig.isEnabledAPB) && this.isPriceBoostContext;
    }
}
